export default __webpack_public_path__ + "static/media/sgd-10.f901202c.png";